module.exports = __webpack_public_path__ + "images/assets/ac05121ecbb810651c820400f14263cf.svg";